import { render } from "./TemplateImport.vue?vue&type=template&id=e37c33c4"
import script from "./TemplateImport.vue?vue&type=script&lang=js"
export * from "./TemplateImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__